"use client";
import React, { useEffect, useState } from "react";
import MainLayout from "@/components/layout/mainLayout";
import BuyNowCart from "@/components/common/BuyNowCart";
import { getCheckoutLineItems } from "@/util/utils";
import NewOctaveBanner from "@/components/newoctavecollection/NewOctaveBanner";
import NewOctaveWhiskyCollection from "@/components/newoctavecollection/NewOctaveWhiskyCollection";
import ScoMeta from "@/components/scometa";
import { useAppCommonStore } from "@/zustand/appCommon";

const Battlehill = (props: any) => {
  const { data, meta } = props;
  const [battlehillData, setBattlehillData]: any = useState(null);

  const {
    checkout,
    setCheckout,
    selectedCountry,
    updateQuantityInCart,
    removeLineItemInCart,
    openModal,
    toggleCartSidebar,
  } = useAppCommonStore((state: any) => ({
    checkout: state.checkout,
    setCheckout: state.setCheckout,
    selectedCountry: state.selectedCountry,
    updateQuantityInCart: state.updateQuantityInCart,
    removeLineItemInCart: state.removeLineItemInCart,
    openModal: state.openModal,
    toggleCartSidebar: state.toggleCartSidebar,
  }));

  useEffect(() => {
    getCheckoutLineItems(selectedCountry.value).then((res) => {
      setCheckout({
        ...res,
      });
    });
  }, []);

  useEffect(() => {
    if (data) {
      setBattlehillData(data?.data?.attributes?.blocks);
    }
  }, [data]);

  const renderBattlehillPage = () => {
    return (
      <>
        {battlehillData && battlehillData.length > 0
          ? battlehillData.map((content: any, index: any) => {
              switch (content.__component) {
                case "sections.banner":
                  return (
                    <NewOctaveBanner
                      data={content}
                      key={content?.id + index}
                      responsiveBanner
                    />
                  );

                case "octave.our-collections":
                  return (
                    <NewOctaveWhiskyCollection
                      key={content?.id + index}
                      data={content}
                      name={"new-octave"}
                      hideCaskNo
                    />
                  );

                default:
                  return null;
              }
            })
          : null}
      </>
    );
  };

  return (
    <>
      <BuyNowCart
        countryCode={selectedCountry.value}
        openModal={openModal}
        toggleCartSidebar={toggleCartSidebar}
        checkout={checkout}
        updateQuantityInCart={updateQuantityInCart}
        removeLineItemInCart={removeLineItemInCart}
      />
      <head>
        <ScoMeta meta={meta ? meta : {}} />
      </head>
      <MainLayout
        checkout={checkout}
        toggleCartSidebar={toggleCartSidebar}
      >
        <div className="single-cask-collection new_octave_collection_container">
          {battlehillData && renderBattlehillPage()}
        </div>
      </MainLayout>
    </>
  );
};

export default Battlehill;
